import styled from 'styled-components';
import { slideInAnimationsMixin } from './animations/slideInAnimationsMixin';
import { CssAnimationVariants } from './types/variant';
const animations = {
    [CssAnimationVariants.SLIDE_IN]: (props) => slideInAnimationsMixin(props),
};
export const CssAnimationContainer = styled.div `
  ${props => {
    return animations[props.variant.type];
}}
`;
//# sourceMappingURL=cssAnimation.styled.js.map